import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Constants from "../../../../constants";
import { ATCAPIService } from "../../../API";
import { getCartList, updateCartItems } from "../../../../actions";
import SingleCartItem from "./SingleCartItem";
import { decodeUserToken, UpdateCartItemsPayload } from "../../../../utils";
import CheckoutSkeleton from "../../../Skeletons/CheckoutSkeleton";
import { getCarItems } from "../../cartUtil";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import QuantityInput from "../QtyInput";





  const ShipmentItemList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  `;

 

  const ShipmentItem = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  `;

  const ShipmentTop = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 0.2rem 1px;
  `;

  const ShipmentImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0.5rem;
    cursor: pointer;

    img {
      width: 130px;
      aspect-ratio: 1/1;
      object-fit: cover;
    }

    @media (max-width: 500px) {

      img {
width: 71px;

      }


}
  `;
  const ShimpentItemDetails = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    
    padding: 0.5rem 1rem;
    p {
      margin: 0;
      cursor: pointer;
    }

    @media (max-width: 500px) {
width: 70%;

      p {
        font-size: 0.8rem;  
line-height: 1.2rem;
        }
}


  `;

  const ShipmentPrice = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    font-size: 0.9rem;
    color: rgb(130, 130, 130);
    font-weight: 500;

    span:first-child {
      color: rgb(65, 65, 65);
      font-weight: 500;
      margin-right: 0.5rem;
      font-size: 1.2rem;
    }
    span:last-child {
      text-decoration: line-through;
      color: rgb(130, 130, 130);
      font-weight: 400;
    }
  `;
  const ShipmentButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0;

    @media(max-width:500px){
    padding:.5rem 0;
    
    flex-wrap:wrap;
    justify-content:flex-start;
    align-content:flex-start; 
    }
  
    `;

    const AddtoWishlistButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    font-size: 0.85rem;
    width: 151px;
    height: 35px;
    cursor: pointer;
    background-color: #fff;
    color: rgb(125, 125, 125);


    @media (max-width: 900px) {
width: 95px;
font-size: 0.75rem;

}
    `
        const DeleteButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    font-size: 0.85rem;
    width: 151px;
    height: 35px;
    cursor: pointer;
    background-color: #fff;
    color: rgb(125, 125, 125);
    margin-left: 1rem;
     @media (max-width: 900px) {
width: 95px;
font-size: 0.75rem;

}
    `

const CartItemNew = (props) => {

    let item = props.item

    const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState({ error: false, errorDetails: "" });
  const {
    cartItem: {
      cartItemDetails = [],
      vendorName = "",
      rate: { expectedDeliveryDate = "" } = {},
    } = {},
  } = props;

  const userDefaultAddress = useSelector(
    (state) => state.userDetails?.defaultAddress || {}
  );

  const { address = {} } = userDefaultAddress;
  const { pinCode = "" } = address;

  const handleUpdateRemoveCart = (e) => {
    setIsLoading(true);
    const { Token = "" } = decodeUserToken();
    const URL = Constants.cart.addToCart;
    const addToCartPayload = UpdateCartItemsPayload({ ...e });
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Token}`,
    };
    console.log("addToCartPayload", addToCartPayload);
    ATCAPIService({ url: URL, data: addToCartPayload, headers })
      .then((response) => {
        const { status = 0, data = {} } = response;
        if (status === 200) {
          setIsError({
            error: false,
            errorDetails: JSON.stringify({
              errorM: "",
              status: "",
            }),
          });
          dispatch(updateCartItems(data?.cartItems));
        } else {
          const { message = "", status = 0 } = response;
          console.log("error_response", response);
          setIsError({
            error: true,
            errorDetails: JSON.stringify({
              errorM: message,
              status: status || "",
            }),
          });
        }
      })
      .then(async () => {
        const AllcartData = await getCarItems({
          setIsError,
          setIsLoading,
          pincode: pinCode,
        });
        if (AllcartData?.data) {
          dispatch(getCartList(AllcartData?.data));
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

   const handleQty = (e) => {
    handleUpdateRemoveCart({ ...e, action: "updateItem" });
  };
const removeItem = (e) => {
    handleUpdateRemoveCart({ ...e, action: "removeItem" });
  };
  return (
   <ShipmentItem key={item?.sku}>
              <ShipmentTop>
                <ShipmentImageContainer onClick={() => {navigate(`/pd/${item?.sku}`)}}>
                  <img src={item?.imageUrl.imageUrl} alt={item?.sku} />
                </ShipmentImageContainer>
                <ShimpentItemDetails >
                  <p onClick={() => {navigate(`/pd/${item?.sku}`)}} >{item.name}</p>
                  <ShipmentPrice onClick={() => {navigate(`/pd/${item?.sku}`)}}>
                    <span>&#8377; {item?.itemPrice?.discountedPrice}</span>
                    <span>&#8377; {item?.itemPrice?.price}</span>
                  </ShipmentPrice>
                  <ShipmentButtonContainer>
                    <AddtoWishlistButton >
                      Add to Wishlist
                    </AddtoWishlistButton>
                    <DeleteButton onClick={() => removeItem({ skuID: item?.sku, variantType: item?.variantType })}>
                      Remove
                    </DeleteButton>

                               <QuantityInput
                                handleQty={handleQty}
                                qty={item.itemCount}
                                skuID={item.sku}
                                variantType={item.variantType}
                              />
                  </ShipmentButtonContainer>

                </ShimpentItemDetails>
              </ShipmentTop>
            </ShipmentItem>
  );
};

export default CartItemNew;
